var _rect, _rect2, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCb = function SvgCb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 43,
    height: 30,
    rx: 4,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 31,
    rx: 4.5,
    stroke: "#000",
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.886 3.915h35.23v24.172H4.886V3.915Z",
    fill: "#29ABE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.886 3.915h35.23v24.172H4.886V3.915Z",
    fill: "url(#cb_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.886 3.915h35.23v24.172H4.886V3.915Z",
    fill: "url(#cb_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.035 9.053h9.41a3.287 3.287 0 1 1 0 6.575h-9.41V9.053Zm0 7.32h9.41a3.287 3.287 0 0 1 0 6.576h-9.41v-6.575Zm-8.198 0v-.745h7.573a7.335 7.335 0 0 0-7.573-6.575A7.28 7.28 0 0 0 8.264 16a7.282 7.282 0 0 0 7.573 6.948 7.333 7.333 0 0 0 7.573-6.575h-7.573Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "cb_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(35.7091 0 0 33.5703 6.843 27.44)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#009245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#049552",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0D9E74",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1BACAB",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FB0B8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "cb_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(45.811 0 0 45.816 12.725 29.512)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1FB0B8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#1C7491",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1A4471",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#18265E",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#181B57"
  })))));
};
export default SvgCb;